import { useEffect, useRef } from 'react';

/**
 *
 * @param callback function invoked after delay
 * @param delay time to next function call in ms. Pass null to pause/stop the polling
 */
export const useInterval = (callback: () => any, delay: number | null) => {
  const savedCallback = useRef<any>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
